export default "__VITE_ASSET__DDLpRiwd__"